import { render, staticRenderFns } from "./manage_assistant_teacher_import.vue?vue&type=template&id=9c2afbe2&class=text_google&"
import script from "./manage_assistant_teacher_import.vue?vue&type=script&lang=js&"
export * from "./manage_assistant_teacher_import.vue?vue&type=script&lang=js&"
import style0 from "./manage_assistant_teacher_import.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VBtn,VIcon,VSystemBar,VToolbarItems})
